import type { PressQuote, PressMention } from "./types";

export const pressQuotes: readonly PressQuote[] = [];
export const pressMentions: readonly PressMention[] = [];
